import script from "./BuyersView.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyersView.vue?vue&type=script&setup=true&lang=js"

import "./BuyersView.vue?vue&type=style&index=0&id=99355692&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99355692"]])

export default __exports__